/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfListOfGetSmartSmsCampaignsListDto } from '../models/custom-result-of-list-of-get-smart-sms-campaigns-list-dto';
import { CustomResultOfListOfGetSmartSmsCampaignStatusInGatewayDto } from '../models/custom-result-of-list-of-get-smart-sms-campaign-status-in-gateway-dto';
import { CustomResultOfPaginatedListOfSmartSmsCampaignsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-smart-sms-campaigns-with-pagination-dto';
import { smartSmsCampaignsAddSmartSmsCampaignToGateway } from '../fn/smart-sms-campaigns/smart-sms-campaigns-add-smart-sms-campaign-to-gateway';
import { SmartSmsCampaignsAddSmartSmsCampaignToGateway$Params } from '../fn/smart-sms-campaigns/smart-sms-campaigns-add-smart-sms-campaign-to-gateway';
import { smartSmsCampaignsCreateGet } from '../fn/smart-sms-campaigns/smart-sms-campaigns-create-get';
import { SmartSmsCampaignsCreateGet$Params } from '../fn/smart-sms-campaigns/smart-sms-campaigns-create-get';
import { smartSmsCampaignsCreatePost } from '../fn/smart-sms-campaigns/smart-sms-campaigns-create-post';
import { SmartSmsCampaignsCreatePost$Params } from '../fn/smart-sms-campaigns/smart-sms-campaigns-create-post';
import { smartSmsCampaignsDelete } from '../fn/smart-sms-campaigns/smart-sms-campaigns-delete';
import { SmartSmsCampaignsDelete$Params } from '../fn/smart-sms-campaigns/smart-sms-campaigns-delete';
import { smartSmsCampaignsGetSmartSmsCampaignsList } from '../fn/smart-sms-campaigns/smart-sms-campaigns-get-smart-sms-campaigns-list';
import { SmartSmsCampaignsGetSmartSmsCampaignsList$Params } from '../fn/smart-sms-campaigns/smart-sms-campaigns-get-smart-sms-campaigns-list';
import { smartSmsCampaignsGetSmartSmsCampaignStatusInGateway } from '../fn/smart-sms-campaigns/smart-sms-campaigns-get-smart-sms-campaign-status-in-gateway';
import { SmartSmsCampaignsGetSmartSmsCampaignStatusInGateway$Params } from '../fn/smart-sms-campaigns/smart-sms-campaigns-get-smart-sms-campaign-status-in-gateway';
import { smartSmsCampaignsGetSmartSmsCampaignsWithPagination } from '../fn/smart-sms-campaigns/smart-sms-campaigns-get-smart-sms-campaigns-with-pagination';
import { SmartSmsCampaignsGetSmartSmsCampaignsWithPagination$Params } from '../fn/smart-sms-campaigns/smart-sms-campaigns-get-smart-sms-campaigns-with-pagination';

@Injectable({ providedIn: 'root' })
export class SmartSmsCampaignsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `smartSmsCampaignsCreateGet()` */
  static readonly SmartSmsCampaignsCreateGetPath = '/SmartSmsCampaigns/Create';

  /**
   * بررسی دسترسی ایجاد کمپین.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsCampaignsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsCampaignsCreateGet$Response(params?: SmartSmsCampaignsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smartSmsCampaignsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی ایجاد کمپین.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsCampaignsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsCampaignsCreateGet(params?: SmartSmsCampaignsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smartSmsCampaignsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smartSmsCampaignsCreatePost()` */
  static readonly SmartSmsCampaignsCreatePostPath = '/SmartSmsCampaigns/Create';

  /**
   * ایجاد کمپین.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsCampaignsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsCampaignsCreatePost$Response(params: SmartSmsCampaignsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsCampaignsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد کمپین.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsCampaignsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsCampaignsCreatePost(params: SmartSmsCampaignsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsCampaignsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsCampaignsDelete()` */
  static readonly SmartSmsCampaignsDeletePath = '/SmartSmsCampaigns/Delete';

  /**
   * حذف کمپین.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsCampaignsDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsCampaignsDelete$Response(params: SmartSmsCampaignsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsCampaignsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف کمپین.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsCampaignsDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsCampaignsDelete(params: SmartSmsCampaignsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsCampaignsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsCampaignsGetSmartSmsCampaignsWithPagination()` */
  static readonly SmartSmsCampaignsGetSmartSmsCampaignsWithPaginationPath = '/SmartSmsCampaigns/GetSmartSmsCampaignsWithPagination';

  /**
   * دریافت لیست کمپین های سازمان فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsCampaignsGetSmartSmsCampaignsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsCampaignsGetSmartSmsCampaignsWithPagination$Response(params: SmartSmsCampaignsGetSmartSmsCampaignsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfSmartSmsCampaignsWithPaginationDto>> {
    return smartSmsCampaignsGetSmartSmsCampaignsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست کمپین های سازمان فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsCampaignsGetSmartSmsCampaignsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsCampaignsGetSmartSmsCampaignsWithPagination(params: SmartSmsCampaignsGetSmartSmsCampaignsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfSmartSmsCampaignsWithPaginationDto> {
    return this.smartSmsCampaignsGetSmartSmsCampaignsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfSmartSmsCampaignsWithPaginationDto>): CustomResultOfPaginatedListOfSmartSmsCampaignsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `smartSmsCampaignsGetSmartSmsCampaignsList()` */
  static readonly SmartSmsCampaignsGetSmartSmsCampaignsListPath = '/SmartSmsCampaigns/GetSmartSmsCampaignsList';

  /**
   * دریافت لیست کمپین های سازمان فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsCampaignsGetSmartSmsCampaignsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsCampaignsGetSmartSmsCampaignsList$Response(params?: SmartSmsCampaignsGetSmartSmsCampaignsList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSmartSmsCampaignsListDto>> {
    return smartSmsCampaignsGetSmartSmsCampaignsList(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست کمپین های سازمان فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsCampaignsGetSmartSmsCampaignsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsCampaignsGetSmartSmsCampaignsList(params?: SmartSmsCampaignsGetSmartSmsCampaignsList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSmartSmsCampaignsListDto> {
    return this.smartSmsCampaignsGetSmartSmsCampaignsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSmartSmsCampaignsListDto>): CustomResultOfListOfGetSmartSmsCampaignsListDto => r.body)
    );
  }

  /** Path part for operation `smartSmsCampaignsGetSmartSmsCampaignStatusInGateway()` */
  static readonly SmartSmsCampaignsGetSmartSmsCampaignStatusInGatewayPath = '/SmartSmsCampaigns/GetSmartSmsCampaignStatusInGateway';

  /**
   * استعلام ایجاد لیست خاکستری در گت وی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsCampaignsGetSmartSmsCampaignStatusInGateway()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsCampaignsGetSmartSmsCampaignStatusInGateway$Response(params?: SmartSmsCampaignsGetSmartSmsCampaignStatusInGateway$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSmartSmsCampaignStatusInGatewayDto>> {
    return smartSmsCampaignsGetSmartSmsCampaignStatusInGateway(this.http, this.rootUrl, params, context);
  }

  /**
   * استعلام ایجاد لیست خاکستری در گت وی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsCampaignsGetSmartSmsCampaignStatusInGateway$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsCampaignsGetSmartSmsCampaignStatusInGateway(params?: SmartSmsCampaignsGetSmartSmsCampaignStatusInGateway$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSmartSmsCampaignStatusInGatewayDto> {
    return this.smartSmsCampaignsGetSmartSmsCampaignStatusInGateway$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSmartSmsCampaignStatusInGatewayDto>): CustomResultOfListOfGetSmartSmsCampaignStatusInGatewayDto => r.body)
    );
  }

  /** Path part for operation `smartSmsCampaignsAddSmartSmsCampaignToGateway()` */
  static readonly SmartSmsCampaignsAddSmartSmsCampaignToGatewayPath = '/SmartSmsCampaigns/AddSmartSmsCampaignToGateway';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsCampaignsAddSmartSmsCampaignToGateway()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsCampaignsAddSmartSmsCampaignToGateway$Response(params: SmartSmsCampaignsAddSmartSmsCampaignToGateway$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsCampaignsAddSmartSmsCampaignToGateway(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsCampaignsAddSmartSmsCampaignToGateway$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsCampaignsAddSmartSmsCampaignToGateway(params: SmartSmsCampaignsAddSmartSmsCampaignToGateway$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsCampaignsAddSmartSmsCampaignToGateway$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
